import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';

import { Controller } from '../common/Controller';
import { UiLoginHelper } from '../common/helpers/UiLoginHelper';
import { Helper } from '../common/helpers/Helper';
import { UsernameInput, PasswordInput, NumericOTPInput } from '../components/TextInputs';
import { AppConfig } from '../AppConfig';
import { AppTheme, } from '../styles/AppTheme'
import { HelmetComponent } from '../common/components/HelmetComponent';

import { AppButton } from '../common/components/AppButton';
import { AppHelper } from '../helpers/AppHelper';

export class LoginCustom extends Component {
  constructor(props) {
    super(props);
    this.userNameType = AppConfig.USER_PRIMARY === 'email' ?
      UiLoginHelper.UserNameType.EMAIL : UiLoginHelper.UserNameType.PHONE
    this.state = {
      currentPage: UiLoginHelper.Page.LOOKUP,
      loadingAnimation: false,
      message: '',
      userName: '',
      pword: '',
      verificationCode: ''
    };
    this.loginHelper = new UiLoginHelper(this, {
      autoSignUp: false,
      autoLogin: true,
      userNameType: this.userNameType,
      jsonBody: this.props.jsonBody ? this.props.jsonBody : {},
      onSuccessLogin: this.onSuccessLogin.bind(this)
    });
  }

  onSuccessLogin() {
    Controller.get().userMgr().setGuestUser(false);
    //console.log('onSuccessLogin');
    if (this.props.onSuccessLogin) {
      this.props.onSuccessLogin()
      return
    }
    window.location.href = Controller.get().roleHelper().getHome()
  }

  render() {
    return (
      <div className={css(Styles.container)}>
        <div className={css(Styles.loginPanelContainer)}>
          {!AppHelper.isOohConsoleHost() &&
            <div className={css(Styles.logoContainer)}>
              <Link to={'/'}>
                <img src={require('../assets/images/logo.png')}
                  alt={AppConfig.NAME} className={css(Styles.img)} />
              </Link>
            </div>
          }
          <div className={css([Styles.loginPanel, this.props.loginPanelStyle])}>

            <HelmetComponent page={'login'} />

            <h2 className={css(Styles.pageTitle)}>{Helper.getString('welcome')}</h2>

            <div className={css(Styles.loginMessageContainer)}>
              {this.state.message.length > 0 &&
                <p className={css(Styles.loginMessage)}>{this.state.message}</p>
              }
            </div>

            {this.state.currentPage === UiLoginHelper.Page.LOOKUP &&
              this.welcomeView()
            }
            {this.state.currentPage === UiLoginHelper.Page.SIGNUP &&
              this.signUpView()
            }
            {this.state.currentPage === UiLoginHelper.Page.SIGNUP_OTP &&
              this.signUpOTPView()
            }
            {this.state.currentPage === UiLoginHelper.Page.LOGIN &&
              this.loginView()
            }
            {this.state.currentPage === UiLoginHelper.Page.RESET_PASSWORD &&
              this.resetPasswordView()
            }
            {this.state.currentPage === UiLoginHelper.Page.RESET_PASSWORD_OTP &&
              this.resetPasswordOTPView()
            }
          </div>
        </div>

        <div className={css(Styles.loginImgContainer)} >
          <img src={require('../assets/images/dolphin-login.png')}
            className={css(Styles.loginImg)} />
        </div>

      </div>
    );
  }

  welcomeView() {
    return (
      <div>
        <UsernameInput
          id='userName'
          value={this.state.userName}
          userNameType={this.userNameType}
          onChange={(event) => this.setState({ userName: event.target.value })}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              this.loginHelper.onSubmitLookup()
            }
          }}
        />

        <div className={css(Styles.buttonContainer)}>
          <AppButton
            buttonStyle={Styles.button}
            disabled={this.state.loadingAnimation}
            onClick={this.loginHelper.onSubmitLookup.bind(this.loginHelper)}
            buttonText={'Continue'}
            inProcess={this.state.loadingAnimation}
          />
        </div>
        {this.props.showTerms &&
          <div className={css(Styles.termsContainer)}>
            <span>By continuing, you agree to our </span><a target='_blank' href={AppConfig.TERMS}>terms</a>
          </div>
        }
      </div>
    )
  }

  signUpView() {
    return (
      <div>
        <UsernameInput
          id='userName'
          value={this.state.userName}
          userNameType={this.userNameType}
          onChange={(event) => this.setState({ userName: event.target.value })} />

        <PasswordInput
          value={this.state.pword}
          onChange={(event) => this.setState({ pword: event.target.value })}
          placeholder='Set a new password'
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              this.loginHelper.onSubmitSignUp()
            }
          }}
        />

        <div className={css(Styles.buttonContainer)}>
          <AppButton
            buttonStyle={Styles.button}
            disabled={this.state.loadingAnimation}
            inProcess={this.state.loadingAnimation}
            buttonText={'Signup'}
            onClick={this.loginHelper.onSubmitSignUp.bind(this.loginHelper)}
          />
        </div>

        <a className={css(Styles.loginLink)} onClick={this.onStartoverClicked.bind(this)}><p>Start over</p></a>
      </div>
    )
  }

  signUpOTPView() {
    return (
      <div>
        <NumericOTPInput
          id='verificationCode'
          value={this.state.verificationCode}
          onChange={(event) => this.setState({ verificationCode: event.target.value })}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              this.loginHelper.onSubmitSignUpConfirm()
            }
          }} />

        <div className={css(Styles.buttonContainer)}>
          <AppButton
            buttonStyle={Styles.button}
            disabled={this.state.loadingAnimation}
            inProcess={this.state.loadingAnimation}
            onClick={this.loginHelper.onSubmitSignUpConfirm.bind(this.loginHelper)}
            buttonText={'Submit'}
          />
        </div>

        <a className={css(Styles.loginLink)} onClick={this.onStartoverClicked.bind(this)}><p>Start over</p></a>
      </div>
    )
  }

  loginView() {
    return (
      <div>
        <UsernameInput
          id='userName'
          value={this.state.userName}
          userNameType={this.userNameType}
          onChange={(event) => this.setState({ userName: event.target.value })} />

        <PasswordInput
          id='pword'
          value={this.state.pword}
          onChange={(event) => this.setState({ pword: event.target.value })}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              this.loginHelper.onSubmitLogin()
            }
          }} />

        <div className={css(Styles.buttonContainer)}>
          <AppButton
            buttonStyle={Styles.button}
            disabled={this.state.loadingAnimation}
            inProcess={this.state.loadingAnimation}
            onClick={this.loginHelper.onSubmitLogin.bind(this.loginHelper)}
            buttonText={'Login'}
          />
        </div>

        <a className={css(Styles.loginLink)} onClick={this.onResetPasswordClicked.bind(this)}><p>Reset password? Get OTP</p></a>
        <a className={css(Styles.loginLink)} onClick={this.onStartoverClicked.bind(this)}><p>Start over</p></a>
      </div>
    );
  }

  resetPasswordView() {
    return (
      <div>
        <UsernameInput
          id='userName'
          value={this.state.userName}
          userNameType={this.userNameType}
          onChange={(event) => this.setState({ userName: event.target.value })}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              this.loginHelper.onSubmitResetPassword()
            }
          }} />

        <div className={css(Styles.buttonContainer)}>
          <AppButton
            buttonStyle={Styles.button}
            disabled={this.state.loadingAnimation}
            inProcess={this.state.loadingAnimation}
            onClick={this.loginHelper.onSubmitResetPassword.bind(this.loginHelper)}
            buttonText={'Get OTP'}
          />
        </div>

        <a className={css(Styles.loginLink)} onClick={this.onStartoverClicked.bind(this)}><p>Start over</p></a>
      </div>
    )
  }

  resetPasswordOTPView() {
    return (
      <div>
        <NumericOTPInput
          id='verificationCode'
          value={this.state.verificationCode}
          onChange={(event) => this.setState({ verificationCode: event.target.value })} />

        <PasswordInput
          id='pword'
          value={this.state.pword}
          onChange={(event) => this.setState({ pword: event.target.value })}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              this.loginHelper.onSubmitConfirmResetPassword()
            }
          }} />

        <div className={css(Styles.buttonContainer)}>
          <AppButton
            buttonStyle={Styles.button}
            disabled={this.state.loadingAnimation}
            inProcess={this.state.loadingAnimation}
            onClick={this.loginHelper.onSubmitConfirmResetPassword.bind(this.loginHelper)}
            buttonText={'Submit'}
          />
        </div>
        <a className={css(Styles.loginLink)} onClick={this.onStartoverClicked.bind(this)}><p>Start over</p></a>
      </div>
    )
  }

  onStartoverClicked() {
    this.loginHelper.toPage(UiLoginHelper.Page.LOOKUP);
  }

  onResetPasswordClicked() {
    this.loginHelper.toPage(UiLoginHelper.Page.RESET_PASSWORD);
  }
}

const Styles = StyleSheet.create({
  buttonContainer: {
    display: 'flex',
    flex: 1,
    marginTop: 20
  },
  button: {
    flex: 1,
    borderRadius: 12
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    width: '100%',
    maxHeight: '100vh'
  },
  loginPanel: {
    borderRadius: 8,
    backgroundColor: '#ffffff',
    width: 300,
    padding: 20,
    '@media (max-width: 767px)': {
      width: 280,
      padding: 10,
      margin: 5,
    },
    '@media (max-width: 320px)': {
      width: 240,
      padding: 10,
      margin: 5
    }
  },
  loginMessageContainer: {
    minHeight: 37
  },
  loginMessage: {
    marginBottom: 0,
    marginTop: 20,
    fontSize: 14,
    color: AppConfig.TINT_COLOUR
  },
  loginLink: {
    marginTop: 10,
    cursor: 'pointer',
    color: 'black',
    fontSize: 14,
    textDecoration: 'underline'
  },
  paddingTop20px: {
    paddingTop: 20
  },
  marginLeft: {
    marginLeft: 10
  },
  termsContainer: {
    marginTop: 10,
    fontSize: 14
  },
  buttonStyle: {
    boxShadow: 'none',
    backgroundColor: AppTheme.buttonBg,
    color: AppTheme.buttonTextColor,
    textAlign: 'center',
    letterSpacing: 0,
    textTransform: 'uppercase',
    opacity: 1,
    borderRadius: 12,
  },
  loginPanelContainer: {
    display: 'flex',
    flex: 1.3,
    flexDirection: 'column',
    alignItems: 'center'
  },
  logoContainer: {
    textAlign: 'left',
    display: 'flex',
    justifyContent: 'flex-start',
    width: '83%',
    padding: '20px 50px',
    height: 100,
    '@media(max-width: 767px)': {
      padding: '20px 0px',
    },
  },
  logoImage: {
    width: 160,
    height: 33,
    '@media(max-width: 767px)': {
      width: 'unset',
      height: 25,
    },
  },
  loginImgContainer: {
    display: 'flex',
    flex: 1,
    '@media(max-width: 767px)': {
      display: 'none'
    },
  },
  formControlMargin: {
    marginTop: 10
  },
  paddingTop30px: {
    paddingTop: 20
  },
  pageTitle: {
    fontSize: 34,
    margin: 0,
  },
  fieldsContainer: {
  },
  img: {
    width: 250,
    height: 'auto',
    maxHeight: '100%',
    maxWidth: '100%',
    '@media(max-width: 767px)': {
      width: 150,
    }
  },
  loginImg: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flex: 1, 
    objectFit: 'contain'
  },
})




// WEBPACK FOOTER //
// ./src/screens/LoginCustom.js